import requestRefData from './requestRefData';
import { requestRefMeta } from './requestRefMeta';
import { REFER_TYPE, REFER_EQUIPMENT } from '../referType';
import { mulLanguage } from '../../refer_context/formatter';
import ReferCache from '../ReferCache'
import referFilters from './referFilter'

export default class DataLoader {
    constructor(referContext) {
        this.referContext = referContext
        try {
            this.domainKey = referContext.props.pageStore.params.domainKey;
            this.serviceCode = referContext.props.pageStore.query.serviceCode;
        } catch {
            console.error("没配置pageStore!")
        }
        this.dataSourceAlias = referContext.props.dataSourceAlias;
    }  

    // 组装请求参数
    getDataLoader({pageInfo, searchKey, exactQuery, stopStatus, referType, dataType, path, billnum, busiObj}, otherParams) {
        let condition;
        if (exactQuery && searchKey) {
            condition = referFilters.getExactQuery(this.referContext, searchKey)
        } else {
            searchKey = this.referContext.searchKey || searchKey
        }
        if (stopStatus !== undefined) {
            condition = referFilters.getStopStatus(condition, stopStatus)
        }
        const { filterConditions, conditionIsNull, isMasterOrg } = this.referContext.props;
        // 参照过滤
        let treetableFilter = this.referContext.props.treetableFilter || 'TreeTable'; // 树表参照过滤类型
        let flag = false;
        if (treetableFilter !== 'TreeTable' && treetableFilter === referType) { // 只过滤树或只过滤表
            flag = true;
        } else if (treetableFilter === 'TreeTable') { // 同时过滤
            flag = true;
        }
        if (filterConditions && flag) {
            condition = referFilters.handleFilterParams(filterConditions, conditionIsNull, condition, this.referContext);
        }
        let page = { // 分页(表参照)
            pageIndex: pageInfo?.pageIndex,
            pageSize: pageInfo?.pageSize,
            totalCount: this.referContext.equipment === REFER_EQUIPMENT.PC ? 0 : 1
        }
        let requestData = {
            page: pageInfo ? page : undefined,
            refCode: this.referContext.refCode,
            likeValue: exactQuery || !searchKey ? undefined : searchKey, // 模糊搜索
            condition,
            dataType: this.referContext.metaDataObj.isTreeList ? 'tree' : dataType, // 树表参照, 以表参照的形式展示, 但请求的时候需要传tree
            path, billnum,
            isMasterOrg: isMasterOrg,
            masterOrgValue: this.referContext.props.pageStore.params.orgId || undefined // 权限过滤: 不能用参照过滤进行权限过滤,从pageStore中取orgId,orgId为当前单据主组织字段,将值传给getRefData接口(传参masterOrgValue), 只要有值就传
        }
        let params = {
            domainKey: this.domainKey, busiObj,
            datasource: this.dataSourceAlias, // 对应主表或子表的alias, 在子表时, 如果倒数第二位是行号就向前取一位
            serviceCode: this.serviceCode,
            refCode: this.referContext.refCode,
            feV: 6
        };
        return this.getData(requestData, params, referType)
    }

    // 请求列表数据
    async getData(requestData, params, referType) {
        try {
            await this.referContext.props.getReferData?.({requestData, params});
            await this.referContext.props.onGetReferData?.({requestData, params});
            // 兼容脚本打开弹窗方案
            await this.referContext.getReferDataCallback?.({requestData, params})
            let data = await requestRefData(requestData, params, this.referContext) // 参照列表数据接口
            if (data === null) return { total: 0, dataSource: [] }
            if (REFER_TYPE.TABLE === referType) { // 表参照
                this.referContext.dataSource = data.recordList;
                this.handleMulLanguage(data.recordList)
                return { total: data.recordCount, dataSource: data.recordList }
            } else if (REFER_TYPE.TREE === referType) { // 树参照
                this.handleMulLanguage(data)
                this.referContext.dataSource = data;
                return data;
            } else {
                this.referContext.dataSource = [];
                return []
            }
        } catch (error) {
            console.error('获取列表数据接口失败:', error)
            // this.referContext.props.pageStore.rootStore.utils.message.danger(`获取列表数据接口失败:${error}`);
            this.referContext.dataSource = [];
            // 表参照
            if (REFER_TYPE.TABLE === referType) return { total: 0, dataSource: [] }
            else return [];
        }
    }

    // 处理多语
    handleMulLanguage(data) {
        data.map(item => {
            if (typeof this.referContext.props.refReturn === 'string') {
                item[this.referContext.props.refReturn] = mulLanguage(item[this.referContext.props.refReturn])
            } else {
                this.referContext.props.refReturn.forEach(r => {
                    item[r] = mulLanguage(item[r])
                })
            }
        })
    }

    // 获取元数据并缓存起来
    async getMetaLoader() {
        try {
            if (this.referContext.metaDataObj.referType) {
                return this.referContext.metaDataObj
            }
            // 创建indexDB实例
            let key = `${location.origin}_${this.referContext.refCode}_${this.domainKey}_${this.serviceCode}`
            const cache = await ReferCache.getInstance(key);
            // 先从indexDB中取meta
            // let _meta = await cache.get(key);
            let _meta = await cache.getCacheWindow(key);
            // if (_meta && _meta.value) {
            //     // this.referContext.metaDataObj = _meta.value
            //     this.referContext.metaDataObjCache[this.referContext.refCode] = _meta.value;
            //     return _meta.value
            // }
            if (_meta) {
                this.referContext.metaDataObjCache[this.referContext.refCode] = _meta;
                return _meta
            }
            // 发接口请求meta
            let metaDataObj = await requestRefMeta(this.referContext, this.domainKey, this.serviceCode);
            this.referContext.metaDataObjCache[this.referContext.refCode] = metaDataObj;
            // this.referContext.metaDataObj = metaDataObj;
            // cache.set(key, metaDataObj) // 往indexDB中也存一份
            cache.setCacheWindow(key, metaDataObj)
            return metaDataObj
        } catch (error) {
            console.error('获取元数据接口失败:', error)
            this.referContext.props.pageStore.rootStore.utils.message.danger(`${lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_194309500558000E', '获取元数据接口失败:')}${error}`);
            return []
        }
    }
}
